<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  created() {
    // 判断是否移动端，直接跳走
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      // 写个异步，正常拿的路由老是空的
      setTimeout(() => {
        if (this.$route.fullPath.indexOf('mobile') === -1) {
          this.$router.replace('/mobile/home')
        }
      }, 100);
    }
  }
}
</script>

<style lang="scss">
html,
body {
  margin: 0;
  padding: 0;
}

/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 1);
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  background: #193759;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
}

.mainContainer {
  width: 100vw;
  margin: auto;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  font-family: "Microsoft YaHei";

  .detailScreen {
    width: 100vw;
    padding-top: 100px;

    .headImage {
      width: 100vw;
      min-height: 500px;
      // background: rgba(0, 0, 0, .8);
      position: relative;

      img {
        width: 100%;
      }

      .titleCtn {
        position: absolute;
        bottom: 12%;
        width: 40%;
        // background: rgba(110, 111, 114, 0.8);
        // background-image: linear-gradient(180deg, #2B2C27, #5A5F5F);
        background-color: rgba(129, 126, 126, 0.2);
        /* 半透明背景 */
        backdrop-filter: blur(10px);
        /* 创建毛玻璃效果 */
        padding: 30px 40px;
        color: #fff;
        animation: flyIn ease 0.6s 1;
        text-align: center;

        @keyframes flyIn {
          0% {
            transform: translateX(-100%);
          }

          100% {
            transform: translateX(0);
          }
        }

        .title {
          font-weight: bold;
          text-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1);
          font-size: 48px;
          margin-bottom: 12px;
          text-align: center;
          font-family: Arial, Helvetica, sans-serif;
        }



        .info {
          font-size: 18px;
          line-height: 42px;
          text-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1);
          text-align: left;
          display: inline-block;
        }

        .btnCtn {
          margin-top: 32px;
          display: flex;
          justify-content: center;
        }

        .button {
          line-height: 50px;
          color: rgba(255, 255, 255);
          border: 2px solid;
          border-radius: 30px;
          text-align: center;
          font-size: 20px;
          display: inline-block;
          padding: 0 30px;
          cursor: pointer;
          margin: 0 24px;

          &:hover {
            color: rgba(255, 255, 255, .9);
          }
        }
      }
    }

    .navCtn {
      line-height: 60px;
      display: flex;
      padding-left: 20px;
      box-shadow: 0px 0px 10px rgba(15, 91, 183, 0.1);


      .tag {
        margin-right: 20px;

        &::after {
          content: '>';
          margin-left: 20px;
        }

        &:nth-last-child(1) {
          color: #009BFB;

          &::after {
            content: '';
          }
        }
      }
    }
  }

  .contentCtn {
    margin: 40px auto;
    padding: 40px 0;
    width: calc(100vw - 540px);
    min-width: 1200px;
    position: relative;

    &.hasBack {
      &::before {
        content: '';
        position: absolute;
        top: -40px;
        bottom: -40px;
        left: -270px;
        right: -270px;
        background: rgba(182, 215, 255, 0.1);
        z-index: -1;
      }
    }

    .titleCtn {
      text-align: center;
      transform: scale(0.1);
      opacity: 0.1;
      transition: 1s ease;
      margin-bottom: 36px;

      &.animation {
        transform: scale(1);
        opacity: 1;
      }

      .title {
        color: #262626;
        letter-spacing: 2px;
        position: relative;
        z-index: 2;
        font-size: 32px;
        font-weight: bold;
      }

      .titleTranslate {
        color: #eeeeee;
        letter-spacing: 4px;
        transform: translateY(40px);
        z-index: 1;
        font-family: Arial #262626;
        font-size: 64px;
        font-weight: bold;
      }
    }

    .infoCtn {
      margin: 40px auto;
      text-align: center;

      .info {
        font-size: 16px;
        color: #7A7A7A;
        line-height: 32px;
        text-indent: 2em;
        text-align: justify;
        opacity: 0;
        transform: translateY(50px);
        transition: 1s ease;
        display: inline-block;

        &.animation {
          transform: translateY(0);
          opacity: 1;
        }
      }
    }
  }

}


.mobileContentCtn {
  padding-top: 40px;

  .imgAndText {
    width: 100%;
    position: relative;

    .img {
      width: 100%;
    }

    .text {
      position: absolute;
      background-color: rgba(129, 126, 126, 0.2);
      /* 半透明背景 */
      backdrop-filter: blur(10px);
      bottom: 20%;
      left: 0;
      color: #000b12;
      line-height: 50px;
      padding: 0 20px;
      font-size: 18px;
    }
  }

  .mobileContent {
    .titleCtn {
      text-align: center;
      margin-bottom: 20px;

      .title {
        color: #262626;
        letter-spacing: 2px;
        position: relative;
        z-index: 2;
        font-size: 16px;
        font-weight: bold;
      }

      .titleTranslate {
        color: #eeeeee;
        letter-spacing: 1px;
        transform: translateY(10px);
        z-index: 1;
        font-family: Arial #262626;
        font-size: 20px;
        font-weight: bold;
      }
    }

    .infoCtn {
      margin: 20px auto;
      text-align: center;

      .info {
        font-size: 14px;
        color: #7A7A7A;
        line-height: 32px;
        text-indent: 2em;
        text-align: justify;
        display: inline-block;
        padding: 0 20px;
      }

      .boxCtn {
        display: flex;
        justify-content: space-between;
        margin: auto;
        margin-bottom: 12px;
        cursor: pointer;
        padding: 0 20px;

        .box {
          flex: 1;
          height: 140px;
          display: flex;
          flex-direction: column;
          justify-content: end;
          position: relative;
          overflow: hidden;

          .image {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            z-index: -1;
          }

          .titleAndText {
            height: 46px;
            background: rgba(0, 0, 0, 0.6);
            overflow: hidden;
            color: #fff;

            .title {
              height: 46px;
              padding: 0 8px;

              .span1 {
                line-height: 24px;
                font-size: 12px;
              }

              .span2 {
                line-height: 22px;
                font-size: 12px;
              }
            }
          }

          &:nth-child(1) {
            margin-right: 12px;
          }
        }
      }
    }

    .imageCenter {
      width: 70%;
      margin: 20px auto;

      .image {
        width: 100%;
      }
    }

  }
}
</style>
